/******************************************************************
 * @NAME ChenJi
 * @CREATEDATE 2020/10/28
 * @DESC <数据字典，公共方法>
 * ****************************************************************/
import moment from 'moment';
import momentTimezone from 'moment-timezone';

const tagTypeEnum = {
  User: 1000,
  AccessCode: 2000,
  AccessZone: 3000,
  Card: 4000,
  Vehicle: 5000,
  Incident: 7000,
};

const common = {
  noDeviceLicenseText:'Unable to add device: license limit exceeded. please upgrade your license or remove an existing device to continue.',
  licenseType:[
    {label: 'Device', value: 0},
    {label: 'Ultimo Platform', value: 1}
  ],
  /***
   * 其它
   */
  // 无数据显示
  noDataStr: "<div class='utm-table-nodata'><svg class='utm-symbol-font' aria-hidden='true'><use xlink:href='#iconIllustration-Nodata-50'></use></svg><p> No Data </p> </div>",
  noMap: "<div class='utm-table-nodata'><svg class='utm-symbol-font' aria-hidden='true'><use xlink:href='#iconIllustration-Nodata-50'></use></svg><p> No Map </p> </div>",
  loadingStr: "<div class='utm-custom-loading utm-table-loading'>Loading</div>",
  // tag类型
  tagTypeEnum: tagTypeEnum,
  tagType: [
    { label: 'User Tag', value: tagTypeEnum.User },
    { label: 'Access Code Tag', value: tagTypeEnum.AccessCode },
    { label: 'Access Zone Tag', value: tagTypeEnum.AccessZone },
    { label: 'Card Tag', value: tagTypeEnum.Card },
    { label: 'Vehicle Tag', value: tagTypeEnum.Vehicle },
    //{ label: '', value: '' },
    { label: 'Incident Tag', value: tagTypeEnum.Incident },
  ],
  tagTypeObj: {
    [tagTypeEnum.User]: 'User Tag',
    [tagTypeEnum.AccessCode]: 'Access Code Tag',
    [tagTypeEnum.AccessZone]: 'Access Zone Tag',
    [tagTypeEnum.Card]: 'Card Tag',
    [tagTypeEnum.Vehicle]: 'Vehicle Tag',
    [tagTypeEnum.Incident]: 'Incident Tag',
  },
  weekDays: { '0': 'Sun', '1': 'Mon', '2': 'Tue', '3': 'Wed', '4': 'Thur', '5': 'Fri', '6': 'Sat', '10': 'PH' },
  // 周
  weeks: [
    { name: "Sunday", abbr: "Sun.", val: 0 },
    { name: "Monday", abbr: "Mon.", val: 1 },
    { name: "Tuesday", abbr: "Tue.", val: 2 },
    { name: "Wednesday", abbr: "Wed.", val: 3 },
    { name: "Thursday", abbr: "Thur.", val: 4 },
    { name: "Friday", abbr: "Fri.", val: 5 },
    { name: "Saturday", abbr: "Sat.", val: 6 }
  ],
  //账号状态
  accountStatus:[
    { label: 'Inactive', value: 0 },
    { label: 'Active', value: 1 },
    { label: 'Locked', value: 2 },
    { label: 'Expired', value: 3 },
  ],
  /***
   * 用户
   */
  // user类型
  userType: [
    { label: 'Staff', value: 0 },
    { label: 'Visitor', value: 1 },
    { label: 'Vendor', value: 2 },
    { label: 'Tenant', value: 3 }
  ],
  // user report 搜索项
  reportUserType: [
    { label: 'Staff', value: 0 },
    { label: 'Visitor', value: 1 },
    { label: 'Vendor', value: 2 },
    { label: 'Tenant', value: 3 }
  ],
  //门的活动报表状态
  reportDoorType: [
    { label: 'Door Forced Open', value: 8 },
    { label: 'Door Left Open', value: 2 },
    { label: 'Exit Release', value: 9 },
    { label: 'Failed', value: 1 },
    { label: 'Input Release', value: 11 },
    { label: 'Multi-Factor+2FA', value: 10 },
    { label: 'Successful', value: 0 },
    { label: 'Successful(2FA)', value: 3 },
    { label: 'Successful (Multi-Factor)', value: 7 },
    { label: 'System Bypass', value: 12 },
    { label: 'System Lock', value: 5 },
    { label: 'System Normalized', value: 6 },
    { label: 'System Relase', value: 4 },
  ],
  // user状态
  userStatus: [
    { label: 'Enabled', value: 0 },
    { label: 'Disabled', value: 1 },
    { label: 'Expired', value: 2 },
    { label: 'Inactive', value: 3 }
  ],
  // user AC状态
  userACStatus: {
    '0': 'Enabled',
    '1': 'Disabled',
    '2': 'Expired',
    '3': 'Inactive'
  },
  // IC类型
  icType: [
    { label: 'Others', value: 0 },
    { label: 'ID', value: 1 },
    { label: 'Passport', value: 2 },
    { label: 'Staff ID', value: 3 },
    { label: 'Vendor ID', value: 4 },
    { label: 'Tenant ID', value: 5 },
    { label: 'FIN', value: 6 }
  ],
  // 人脸上传错误提示
  errMsg: `File Size: Images should have a file size greater than 20 kilobytes (KB) and less than ${window.g.uploadFaceSize} megabytes (MB).  File Type: jpeg, png & jpg.
        ${'                       '} Dimension: The width and height of the images must exceed 150 x 150 pixels and less than 4096 x 4096 pixels.
  `,

  /***
   * AC
   */
  // AC 类型
  acType: [
    { label: 'User Access Code', value: 0 },
    { label: 'Vehicle Access Code', value: 1 }
  ],
  // AC Source
  acSources: [
    {
      label: "Ultimo",
      value: "Ultimo"
    }
  ],

  /***
   * 设备
   */
  // 设备方向
  deviceDirection: {
    '0': {
      label: "Entry",
      value: 0
    },
    '1': {
      label: "Exit",
      value: 1
    },
    '2': {
      label: "Two Way",
      value: 2
    }
  },
  // 设备大类
  deviceTypeGroup: [
    {
      label: "Control Board",
      value: 1000
    },
    {
      label: "Reader",
      value: 2000,
      isCanAccess: true,
    },
    {
      label: "Camera",
      value: 3000,
      isCanAccess: true,
    },
    {
      label: "Input",
      value: 4000,
      isCanAccess: true,
    },
    {
      label: "Gateway",
      value: 5000
    },
    {
      label: "Others",
      value: 6000
    },
    // {
    //   label: "Barrier Gate",
    //   value: 9998
    // },
    // {
    //   label: "DoorSensor",
    //   value: 9999
    // },
  ],
  // 学生考勤状态
  studentAttendance: {
    '0': {
      label: "Success",
      value: 0
    },
    '1': {
      label: "Late",
      value: 1
    },
    '2': {
      label: "Absent",
      value: 2
    }
  },
  // 出勤报告类型
  attendanceType: [
    {
      label: "Organization",
      value: 3,
    },
    {
      label: "Program",
      value: 2,
    },
    {
      label: "Module",
      value: 1,
    },
    {
      label: "Student",
      value: 0
    },
  ],
  healthItDevice:{
    "6001": {
      label: "UPS",
      value: 6001,
      parent: 6000,
    },
    "6002": {
      label: "Firewall",
      value: 6002,
      parent: 6000,
    },
    "6003": {
      label: "Switch",
      value: 6003,
      parent: 6000,
    },
    "6004": {
      label: "Router",
      value: 6004,
      parent: 6000,
    },
    "6005": {
      label: "Inter-building Network",
      value: 6005,
      parent: 6000,
    },
    //下面两处7001和7002的parent未经考证，随便填了一个
    "7001": {
      label: "EMS2000",
      value: 7001,
      parent: 7000,
    },
    "7002": {
      label: "SP2 Touch",
      value: 7002,
      parent: 7000,
    },
  },
  // 健康检测中判断除了基础设备的设备
  healthDeviceSelect: {
    "1001": {
      label: "Ultimo Controller",
      value: 1001,
      parent: 1000,
      edgeNode: true,
    },
    "1002": {
      label: "Gallagher Controller",
      value: 1002,
      parent: 1000,
      edgeNode:true,//是否需要选择第三方服务
    },
    "1003": {
      label: "Kantech Controller",
      value: 1003,
      parent: 1000,
      isSync:true,
    },
    "1004": {
      label: "Lenel Controller",
      value: 1004,
      parent: 1000,
      isSync: true,
    },
    "1005": {
      label: "CT9 Pro",
      value: 1005,
      parent: 1000,
    },
    "1007": {
      label: "K2 Controller",
      value: 1007,
      parent: 1000,
      edgeNode: true,
    },
    '1009':{
      label:'Hik Acs Controller',
      value:1009,
      parent: 1000,
      isSync: true,
    },
    "2001": {
      label: "Card Reader",
      value: 2001,
      parent: 2000,
      isCanAccess: true,
    },
    "2002": {
      label: "YITU FR Reader",
      value: 2002,
      parent: 2000,
      edgeNode: true,
      isCanAccess: true,
    },

    //PSIM Lite 即Ess独有的设备 PSIM ENT没有
    "2003": {
      label: "JVT FR Reader",
      value: 2003,
      parent: 2000,
    },
    "2004": {
      label: "Gallagher Reader",
      value: 2004,
      parent: 2000,
      isSync: true
    },
    "2005": {
      label: "Gallagher DCS Reader",
      value: 2005,
      parent: 2000,
      source:1001,
      isSync: true // 同步的设备类型,不能添加
    },
    "2006": {
      label: "Fingerprint Reader",
      value: 2006,
      parent: 2000,
      edgeNode:true,//是否需要选择第三方服务
      isSync:true,
    },
    "2007": {
      label: "Kantech Reader",
      value: 2007,
      parent: 2000,
      isSync: true,
    },
    "2008": {
      label: "QR Code Reader",
      value: 2008,
      parent: 2000,
      isCanAccess: true,
    },
    "2009": {
      label: "Lenel Reader",
      value: 2009,
      parent: 2000,
      isSync: true,
      isCanAccess: true,
    },
    "2010": {
      label: "YITU C5 Reader",
      value: 2010,
      parent: 2000,
      isCanAccess: true,
    },
    "2012": {
      label: "FaceSecReader",
      value: 2012,
      parent: 2000,
      isCanAccess: true,
    },
    "2014": {
      label: "Hik Acs Reader",
      value: 2014,
      parent: 2000,
      isSync: true
    },
    "2015": {
      label: "Palm Vein Reader",
      value: 2015,
      parent: 2000,
      isCanAccess: true,
    },
    "3001": {
      label: "IP Camera",
      value: 3001,
      parent: 3000,
      isCanAccess: true,
    },
    "3002": {
      label: "Hik-vision People Counting",
      value: 3002,
      parent: 3000,
      isCanAccess: true,
    },
    "3003": {
      label: "Dahua People Counting",
      value: 3003,
      parent: 3000,
      isCanAccess: true,
    },
    '4001': {
      label: "Gallagher Input",
      value: 4001,
      parent: 4000,
      isSync: true, // 同步的设备类型,不能添加
      isCanAccess: true,
    },
    "4002": {
      label: "IoT Gateway Input",
      value: 4002,
      parent: 4000,
      isCanAccess: true,
    },
    "4003": {
      label: "Door Sensor",
      value: 4003,
      parent: 4000,
      isCanAccess: true,
    },
    "4004": {
      label: "Motion Sensor",
      value: 4004,
      parent: 4000,
      isCanAccess: true,
    },
    "4005": {
      label: "Leak Probe Sensor",
      value: 4005,
      parent: 4000,
      isCanAccess: true,
    },
    "4006": {
      label: "Flood Rope Sensor",
      value: 4006,
      parent: 4000,
      isCanAccess: true,
    },
    "4007":{
      label: "Ambience Monitoring Sensor",
      value: 4007,
      parent: 4000,
      isCanAccess:true,
      isSync: true,
    },
    "4008":{
      label: "Ai Workplace Occupancy Sensor",
      value: 4008,
      parent: 4000,
      isCanAccess:true,
      isSync: true,
    },
    "5001": {
      label: "Ultimo IO Board",
      value: 5001,
      parent: 5000,
    },
    "5002": {
      label: "LoRaWAN IoT Gateway",
      value: 5002,
      parent: 5000,
    },
    "9001": {
      label: "GPS",
      value: 9001,
      parent: 6000,
      isSync: true, // ATS系统同步的设备类型,不能添加
    },
    "9999": {
      label: "Door Sensor",
      value: 9999,
      parent: 9999,
    },
    "1": {
      label: "Barrier Gate",
      value: 1,
      parent: 9998,
    },
    "9002": {
      label: "Broadcast",
      value: 9002,
    },
    "9003": {
      label: "Intercom",
      value: 9003,
    },
    "9004": {
      label: "Phone",
      value: 9004,
    },
    "9005": {
      label: "Camera",
      value: 9005,
    },
    "9006": {
      label: "Microphone",
      value: 9006,
    },
    "9007": {
      label: "Other",
      value: 9007,
    },
  },
  // 设备小类
  deviceType: {
    "1000": {
      label: "Virtual Controller",
      value: 1000,
      parent: 1000,
      // edgeNode: true,
      // isSync: true,
    },
    "1001": {
      label: "Ultimo Controller",
      value: 1001,
      parent: 1000,
      edgeNode: true,
    },
    "1002": {
      label: "Gallagher Controller",
      value: 1002,
      parent: 1000,
      edgeNode:true,//是否需要选择第三方服务
      isSync: true,
    },
    "1003": {
      label: "Kantech Controller",
      value: 1003,
      parent: 1000,
      isSync:true,
    },
    "1004": {
      label: "Lenel Controller",
      value: 1004,
      parent: 1000,
      isSync: true,
    },
    "1005": {
      label: "CT9 Pro",
      value: 1005,
      parent: 1000,
    },
    "1007": {
      label: "K2 Controller",
      value: 1007,
      parent: 1000,
      edgeNode: true,
    },
    '1009':{
      label:'Hik Acs Controller',
      value:1009,
      parent: 1000,
      isSync: true,
    },
    "2001": {
      label: "Card Reader",
      value: 2001,
      parent: 2000,
      isCanAccess: true,
    },
    "2002": {
      label: "YITU FR Reader",
      value: 2002,
      parent: 2000,
      edgeNode: true,
      isCanAccess: true,
    },

    //PSIM Lite 即Ess独有的设备 PSIM ENT没有
    "2003": {
      label: "JVT FR Reader",
      value: 2003,
      parent: 2000,
    },
    "2004": {
      label: "Gallagher Reader",
      value: 2004,
      parent: 2000,
      isSync: true
    },
    "2005": {
      label: "Gallagher DCS Reader",
      value: 2005,
      parent: 2000,
      source:1001,
      isSync: true // 同步的设备类型,不能添加
    },
    "2006": {
      label: "Fingerprint Reader",
      value: 2006,
      parent: 2000,
      edgeNode:true,//是否需要选择第三方服务
      isSync:true,
    },
    "2007": {
      label: "Kantech Reader",
      value: 2007,
      parent: 2000,
      isSync: true,
    },
    "2008": {
      label: "QR Code Reader",
      value: 2008,
      parent: 2000,
      isCanAccess: true,
    },
    "2009": {
      label: "Lenel Reader",
      value: 2009,
      parent: 2000,
      isSync: true,
      isCanAccess: true,
    },
    "2010": {
      label: "YITU C5 Reader",
      value: 2010,
      parent: 2000,
      isCanAccess: true,
    },
    "2012": {
      label: "FaceSecReader",
      value: 2012,
      parent: 2000,
      isCanAccess: true,
    },
    "2013":{
      label: "Hongtu FR Reader",
      value: 2013,
      parent: 2000,
      isCanAccess: true,
     // isSync: true,
    },
    "2014": {
      label: "Hik Acs Reader",
      value: 2014,
      parent: 2000,
      isSync: true
    },
    "2015": {
      label: "Palm Vein Reader",
      value: 2015,
      parent: 2000,
      isCanAccess: true
    },
    "2017" : {
      label: "TF2000 Fingerprint Reader",
      value: 2017,
      parent: 2000,
      isCanAccess: true
    },
    "3001": {
      label: "IP Camera",
      value: 3001,
      parent: 3000,
      isCanAccess: true,
    },
    "3002": {
      label: "Hik-vision People Counting",
      value: 3002,
      parent: 3000,
      isCanAccess: true,
    },
    "3003": {
      label: "Dahua People Counting",
      value: 3003,
      parent: 3000,
      isCanAccess: true,
    },
   /* "3004": {
      label: "People Counting Camera",
      value: 3004,
      parent: 3000,
    },*/
    '4001': {
      label: "Gallagher Input",
      value: 4001,
      parent: 4000,
      isSync: true, // 同步的设备类型,不能添加
      isCanAccess: true,
    },
    "4002": {
      label: "IoT Gateway Input",
      value: 4002,
      parent: 4000,
      isCanAccess: true,
    },
    "4003": {
      label: "Door Sensor",
      value: 4003,
      parent: 4000,
      isCanAccess: true,
    },
    "4004": {
      label: "Motion Sensor",
      value: 4004,
      parent: 4000,
      isCanAccess: true,
    },
    "4005": {
      label: "Leak Probe Sensor",
      value: 4005,
      parent: 4000,
      isCanAccess: true,
      isSync: true, // 同步的设备类型,不能添加
    },
    "4006": {
      label: "Flood Rope Sensor",
      value: 4006,
      parent: 4000,
      isCanAccess: true,
      isSync: true, // 同步的设备类型,不能添加
    },
    "4007":{
      label: "Ambience Monitoring Sensor",
      value: 4007,
      parent: 4000,
      isCanAccess:true,
      isSync: true,
    },
    "4008":{
      label: "Ai Workplace Occupancy Sensor",
      value: 4008,
      parent: 4000,
      isCanAccess:true,
      isSync: true,
    },
    "5001": {
      label: "Ultimo IO Board",
      value: 5001,
      parent: 5000,
      edgeNode:true
    },
    "5002": {
      label: "LoRaWAN IoT Gateway",
      value: 5002,
      parent: 5000,
    },
    "6001": {
      label: "UPS",
      value: 6001,
      parent: 6000,
    },
    "6002": {
      label: "Firewall",
      value: 6002,
      parent: 6000,
    },
    "6003": {
      label: "Switch",
      value: 6003,
      parent: 6000,
    },
    "6004": {
      label: "Router",
      value: 6004,
      parent: 6000,
    },
    "6005": {
      label: "Inter-building Network",
      value: 6005,
      parent: 6000,
    },
    "9001": {
      label: "GPS",
      value: 9001,
      parent: 6000,
      isSync: true, // ATS系统同步的设备类型,不能添加
    },
    "9999": {
      label: "Door Sensor",
      value: 9999,
      parent: 9999,
    },
    "1": {
      label: "Barrier Gate",
      value: 1,
      parent: 9998,
    }
  },
  deviceSource: {
    '0': {
      value: 0,
      label: "Ultimo",
    },
    '1001':{
      value: 1001,
        label: "Gallagher",
    },
    /*'1002':{
      value: 1002,
        label: "Schindler",
    },
    '1003':{
      value: 1003,
        label: "Vivotec",
    },
    '1004':{
      value: 1004,
        label: "AMAG",
    },*/
    '1005': {
      value: 1005,
      label: "Lenel",
    },
    /*'1006':{
      value: 1006,
        label: "Ademco",
    },*/
    '1007': {
      value: 1007,
      label: "Kantech",
    },
    '1008': {
      value: 1008,
      label: "MEGVI",
    },
    '1009': {
      value: 1009,
      label: "Zycoo",
    },
    '1010':{
      value: 1010,
      label: "Hongtu",
    },
    '1011':{
      value:1011,
      label:'Hik Contral'
    },
    '1012':{
      value:1012,
      label:'EntryPass'
    },
    '2001': {
      value: 2001,
      label: "Avigilon",
    },
    //华为摄像头来源
    '2002': {
      value: 2002,
      label: "Huawei NVR",   
    },
    '2004': {
      value: 2004,
      label: "Dahua DSS",
    },
    '2005': {
      value: 2005,
      label: "Huawei IVS 3800",
    },
    // ATS(GPS)
    '2003': {
      value: 2003,
      label: 'ATS'
    },
    '3001': {
      value: 3001,
      label: 'LoRaWAN'
    },
    '3002':{
      value:3002,
      label:'Hik CCTV'
    },
  },
  // 判断展示connection字段或设备在线状态颜色的设备类型
  isShowOnlineDevice: function (device) {
    return device.category === 1000 || device.category === 3000 || device.category === 9999
      || device.type === 2002 || device.type === 2003 || device.type === 2017 || device.category === 9998 || device.type === 5001 || device.type === 5002
      || device.type === 4003 || device.type === 4004 || device.type === 4005 || device.type === 4006 || device.type === 4007;
  },
  /*控制板型号，单门，双门，多门*/
  modelList: {
    '0': {
      label: "One-Door Two-Way",
      value: '0',
    },
    '1': {
      label: "Two-Door Two-Way",
      value: '1',
    },
    '2': {
      label: "Four-Door One-Way",
      value: '2',
    }
  },
  //门的模式
  doorMode: {
    '0': { value: 0, label: 'Normally Access ' },
    '1': { value: 1, label: 'Normally Open ' },
    '2': { value: 2, label: 'Normally Closed' },
  },
  // 门磁的状态
  doorStatus: {
    '0': { value: 0, label: 'Closed' },
    '1': { value: 1, label: 'Opened' },
    // '10':{value:10, label:'Unlocked'},
    // '11':{value: 11, label:'Locked'},
  },
  // 门锁的状态
  doorLockStatus: {
    '0': { value: 0, label: 'Unknown' },
    '1': { value: 1, label: '' },
    '10': { value: 10, label: 'Unlocked' },
    '11': { value: 11, label: 'Locked' },
  },
  IOBoardInputType: {
    '0': { value: 0, label: 'Two Ports Monitoring' },
    '1': { value: 1, label: 'Barrier Normally Opened' },
    '2': { value: 2, label: 'Barrier Normally Closed' },
  },
  /************************************Vehicle 的相关数据 Start************************************/
  vehicleParkMode: [
    { value: 0, label: 'Cycle Parking' },
    { value: 1, label: 'Visitor Parking' },
    { value: 2, label: 'Staff Parking' }
  ],
  vehicleChargeRule: {
    '0': { value: 0, label: 'Monthly Parking' },
    '1': { value: 1, label: 'Season Parking' },
    '2': { value: 2, label: 'Specific Number Days Parking' },
    '3': { value: 3, label: 'Customize' },
  },
  parkingChargeCycleType: [
    { value: 0, label: 'Monthly' },
    { value: 1, label: 'Season' },
  ],
  vehicleStatus: [
    { value: 0, label: 'Enabled' },
    { value: 1, label: 'Disabled' },
    { value: 2, label: 'Expired' },
    { value: 3, label: 'Inactive' },
  ],
  barrierGateStatus: {
    '0': { value: 0, label: 'Closed' },
    '1': { value: 1, label: 'Open' },
  },
  barrierGateMode: {
    '0': { value: 0, label: 'Automatic' },
    '1': { value: 1, label: 'By Pass' },
    '2': { value: 2, label: 'Fire Alarm' },
  },
  gpsDeviceStatus: [
    { value: 0, label: 'Online' },
    { value: 0, label: 'Offline' }
  ],
  operationContentTypes: [
    { value: 0, label: 'Release the Barrier' },
    { value: 1, label: 'Place the Barrier' },
    { value: 2, label: 'Automatic to By Pass' },
    { value: 3, label: 'Automatic to Fire Alarm' },
    { value: 4, label: 'By Pass to Automatic' },
    { value: 5, label: 'By Pass to Fire Alarm' },
    { value: 6, label: 'Fire Alarm to Automatic' },
    { value: 7, label: 'Fire Alarm to By Pass' }
  ],
  operationTypes: [
    { value: 0, label: 'Switch Barrier Mode' },
    { value: 1, label: 'Control Barrier Gate' },
  ],
  defaultMonetaryUnits: {
    'USD': '$',
    'RMB': '￥',
    'THB': '฿',
    'MYR': 'MYR',
    'SGD': 'S$',
  },
  /************************************Vehicle 的相关数据 End************************************/

  /***
   * 事件
   */
  eventLevelName: 'Severity', // 事件等级显示名
  eventLevelPrefix: 'S',
  // eventLevelName:'Priority', // 事件等级显示名
  // eventLevelPrefix: 'P',//事件等级前缀
  inputStr: { // 输入的固定字符串
    //'0': 'The selected user group is identified by the selected device group.',
  },
  // outPut字段名
  outputStr: {
    '0': 'In-App Message',
    '1': 'Email',
    '2': 'SMS',
    '3': 'Tel',
    '4': 'I/O',
    '5': 'Audio',
    '7': 'Data Output',
    '8': 'Telegram'
  },
  incidentType: {
    4005: 'Input Opened',
    3008: 'Abnormal Temperature'
  }, // 所有事件类型(由接口获取)
  incidentTypeList: [], //事件列表
  systemNotificationIncidentTypes: [
    1001, 1002, 1003, 5001, 6001, 6002
  ],
  alarmList: [],
  notificationList: [],
  taskList: [],
  incidentSources: {
    '0': {
      label: "Ultimo",
      value: 0
    },
    '1': {
      label: "Ultimo", // 0和1统一名字(PSIM Pro #3267)
      value: 1,
      disableSelect: true
    },
    '2': {
      label: "Lenel",
      value: 2,
      disableSelect: true
    },
    '3': {
      label: "Avigilon",
      value: 3,
    },
    '4': {
      label: "Gallagher",
      value: 4,
    },
    '5': {
      label: "Vtrack",
      value: 5,
    },
    '7': {
      label: "VivotekNVR",
      value: 7,
      disableSelect: true
    },
    '8': {
      label: "EMS2000",
      value: 8,
      disableSelect: true
    },
    '9': {
      label: "SP2Touch",
      value: 9,
      disableSelect: true
    },
    '10': {
      label: "PSIM Mobile",
      value: 10,
      disableSelect: true
    },
    '12': {
      label: "PSIM ENT",
      value: 12,
      disableSelect: true
    },
    '14':{
      label:'Tapway',
      value: 14,
    }

  },
  // 获取事件source选项
  getIncidentSourceOptions: function () {
    let sourceArr = [];
    let sources = this.incidentSources;
    for (let sourceKey in sources) {
      let item = sources[sourceKey];
      if (!item.disableSelect) {
        sourceArr.push(item);
      }
    }
    sourceArr.sort((a, b) => {
      return (a.label > b.label) - (a.label < b.label);
    });
    return sourceArr;
  },
  // 多卡开门方式
  doorAccessVerifyType: {
    '0': 'Card',
    '1': 'Card + PIN',
    '2': 'Face + PIN',
    '3': 'QR Code + PIN',
  },
  alarmOvertimeStatus: [
    {
      value: 0,
      label: 'UnProcess'
    },
    {
      value: 1,
      label: 'Processing'
    },
    {
      value: 2,
      label: 'Completed'
    },
    {
      value: 3,
      label: 'Closed'
    },
  ],
  // 事件处理方式
  eventDisposeType: [
    { label: 'Acknowledge', value: 0 },
    { label: 'False Alarm', value: 1 },
    { label: 'Read only', value: 2 }
  ],
  // task状态
  taskStatus: [
    // 已处理（按时完成）
    {
      value: 0,
      label: 'Close'
    },
    // 处理中（按时完成）
    {
      value: 1,
      label: 'Open'
    },
    // 挂起（推迟）
    {
      value: 2,
      label: 'Open'
    },
    // 超时完成
    {
      value: 3,
      label: 'Overtime Close'
    },
    // 已超时
    {
      value: 4,
      label: 'Overtime'
    },
  ],
  // 事件状态
  eventStatus: [
    // 未处理
    { label: 'Notified', value: 10 },
    // 处理中
    { label: 'Processing', value: 11 },
    // 已处理
    { label: 'Closed', value: 12 },
    // 已忽略
    { label: 'NA', value: 13 },
    // 已读
    { label: 'Read', value: 14 },
    // 未读
    { label: 'Unread', value: 15 },
    // 超时
    { label: 'Overtime', value: 16 },
    // 超时完成
    { label: 'Overtime Close', value: 17 },
  ],
  /* **********ICS********* */
  icsDeviceTypes:{
    '0':{name:'All Type', icon:'utm-ics-type-icon',type:0},
    '3':{name:'Phone', icon:'utm-ics-phone-icon',type:3},
    // '6':{name:'Microphone', icon:'utm-ics-announce-icon',type:6},
    '1':{name:'Broadcast', icon:'utm-ics-broadcast-icon',type:1},
    '2':{name:'Intercom', icon:'utm-ics-intercom-icon',type:2},
    // '4':{name:'Camera', icon:'utm-ics-camera-icon',type:4},
    // '7':{name:'Other', icon:'utm-ics-other-icon',type:7},
  },
  /***
   * 服务
   */
  integrationTypes: [
    {
      label: "QR Code Service",
      value: 'ultimo.essential.qrcode'
    }
  ],
  // 服务类型
  serviceTypes: {
    1001: {
      label: "Edge Node",
      value: 1001
    },
    1002: {
      label: "Yitu FR Engine Server",
      value: 1002
    },
    /*    1003:{
          label:"AMAG",
          value:1003
        },*/
    1004:{
      label:"Gallagher",
      value:1004
    },
    1005: {
      label: "Lenel",
      value: 1005
    },
    1006:{
      label:"Kantech",
      value:1006
    },
    1008: {
      label: "Edge Node K2",
      value: 1008
    },
    1009:{
      label: "Hongtu 3000",
      value: 1009
    },
    1010:{
      label:'Hik Acs',
      value: 1010
    },
    1012:{
      label:'EntryPass',
      value: 1012
    },
    2001: {
      label: "Yitu AI Box",
      value: 2001
    },
    2002: {
      label: "Avigilon",
      value: 2002
    },
    2003: {
      label: 'Vtrack',
      value: 2003
    },
    2004: {
      label: 'Avigilon AI',
      value: 2004
    },
    2006: {
      label: 'Vivotek NVR',
      value: 2006
    },
    2007: {
      label: 'Huawei NVR',
      value: 2007
    },
    2008: {
      label: 'Megvii AI Box',
      value: 2008
    },
    2009: {
      label: 'Dahua DSS',
      value: 2009
    },
    2011: {
      label: 'Huawei IVS 3800',
      value: 2011
    },
    2010:{
      label:'Hik CCTV',
      value:2010
    },
    3001: {
      label: "Schindler",
      value: 3001
    },
    3002: {
      label: "DFRS",
      value: 3002
    },
    3003: {
      label: "Fireman",
      value: 3003
    },
    4001: {
      label: "Suprema",
      value: 4001
    },
    5001: {
      label: 'Email',
      value: 5001
    },
    5002: {
      label: 'ICS',
      value: 5002
    },
    5003: {
      label: 'EAP',
      value: 5003
    },
    5004: {
      label: 'SMS',
      value: 5004
    },
    5005:{
      label:'Edge Node I/O Board',
      value: 5005
    },
    6001: {
      label: 'Huawei eSight',
      value: 6001
    },
    6002: {
      label: 'Solarwinds SEM',
      value: 6002
    },
    10001: {
      label: 'APN',
      value: 10001
    },
    10002: {
      label: 'NTP',
      value: 10002
    },
  },
  // 健康检测服务器类型
  healthSystemServiceTypes: {
    0: {
      label: "Basic ",
      value: 0
    },
    1: {
      label: "Integration",
      value: 1
    },
    2: {
      label: "External ",
      value: 2
    },
  },
  // System Service类型
  systemServiceTypes: {
    0: {
      label: "Ultimo",
      value: 0
    },
    1: {
      label: "Integration",
      value: 1
    },
  },
  // 外部System Service类型
  externalSystemServiceTypes: {
    0: {
      label: "Ultimo",
      value: 0
    },
    1: {
      label: "Integration",
      value: 1
    },
  },
  // 服务器分类
  serverClassification: {
    0: {
      label: "Internal Server",
      value: 0
    },
    1: {
      label: "3rd Party Server",
      value: 1
    },
  },
   // 服务器类型
   serverTypes: {
    0: {
      label: "Physical Server",
      value: 0
    },
    1: {
      label: "Virtual Server",
      value: 1
    },
  },
  incidentServerTypes: {
    0: {
      label:  'Internal Server',
      value: 0
    },
    1: {
      label: "3rd Party Server",
      value: 1
    },
  },
  //user login报表system name搜索项
  systemNames: [
    { label: 'ARMS Mobile', value: 'ARMS Mobile' },
    { label: 'PSIM Mobile', value: 'PSIM Mobile' },
    { label: 'PSIM', value: 'PSIM' },
    { label: 'PlAZA 1', value: 'PlAZA 1' },
    { label: 'PLAZA 2', value: 'PLAZA 2' },
    { label: 'TC', value: 'TC' },
    { label: 'FEB', value: 'FEB' },
    { label: 'AB', value: 'AB' },
    { label: 'PSIM Config', value: 'PSIM Config' },
    { label: 'Global Config', value: 'Global Config' },
    { label: 'PLAZA 1 Config', value: 'PLAZA 1 Config' },
    { label: 'PLAZA 2 Config', value: 'PLAZA 2 Config' },
    { label: 'FEB Config', value: 'FEB Config' },
    { label: 'TC Config', value: 'TC Config' },
    { label: 'AB Config', value: 'AB Config' }
  ],

  /***
   * 报表
   */
  // data change
  operateType: [
    { label: 'Create', value: 0 },
    { label: 'Modify', value: 1 },
    { label: 'Delete', value: 2 }
  ],

  //把十六进制颜色转换为rgb
  colorToRgba: function (str, opacity) {
    if(!str){
      return '';
    }
    // 16进制颜色值的正则
    let reg = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
    // 把颜色值变成小写
    let color = str.toLowerCase();
    if (reg.test(color)) {
      // 如果只有三位的值，需变成六位，如：#fff => #ffffff
      if (color.length === 4) {
        let colorNew = "#";
        for (let i = 1; i < 4; i += 1) {
          colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
        }
        color = colorNew;
      }
      // 处理六位的颜色值，转为RGB
      let colorChange = [];
      for (let i = 1; i < 7; i += 2) {
        colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
      }
      return "rgba(" + colorChange.join(",") + "," + opacity + ")";
    } else {
      return color;
    }
  },


  //Access Zone 的状态
  accessZoneStatus: {
    '0': { value: 0, label: 'Enabled' },
    '1': { value: 1, label: 'Disabled' },
    '10': { value: 10, label: 'Complete ' },
    '11': { value: 11, label: 'Incomplete' },
  },
  accessZoneType: {
    '0': { value: 0, label: 'Monitoring Access Zone' },
    '1': { value: 1, label: 'Door Access Control' },
    '2': { value: 2, label: 'Barrier Gate' },
    '3': { value: 3, label: 'Alarm Monitoring' },
  },

  /********************************公共方法*********************************/
  //  格式化日期
  /*time时间
  str:要转换的格式
  type：可不传，如果不传，以当前时间格式转化，如果传了不管当前什么格式，优先将传过来的时间转成‘日月年’
  */
  //使用方法：
  /*后端转前端：this.formatDate('',this.$root.Time[this.$root.Time.type].typeDate);
              或者this.$root.Time[this.$root.Time.type].typeDateHM
              或者this.$root.Time[this.$root.Time.type].typeTime*/
  /*前端转后端：this.formatDate('',this.$root.Time[this.$root.Time.type].typeDate,true);
              或者this.$root.Time[this.$root.Time.type].typeDateHM
              或者this.$root.Time[this.$root.Time.type].typeTime*/

  formatDate: function (time, formatStr, type, isSecond) {
    /*isSecond -- 时间戳为s*/
    let str = '';
    if (!time) {
      return;
    }
    if (type === true) {
      switch (formatStr) {/*默认优先转成年月日格式*/
        case 'dd-MM-yyyy':
          str = moment(time, 'DD-MM-YYYY').format('YYYY-MM-DD');
          break;
        case 'yyyy-MM-dd HH:mm':
          str = moment(time, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
          break;
        case 'dd-MM-yyyy HH:mm':
          str = moment(time, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm');
          break;
        case 'yyyy-MM-dd HH:mm:ss':
          str = moment(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
          break;
        case 'dd-MM-yyyy HH:mm:ss':
          str = moment(time, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
          break;
        default:
          str = moment(time, 'YYYY-MM-DD').format('YYYY-MM-DD');
          break;
      }
    } else if (type === 1) {/*时间戳转化成时间格式(Unix 时间戳)*/
      let unixSign = isSecond ? 'X' : 'x';
      switch (formatStr) {
        case 'yyyy-MM-dd HH:mm':
          str = moment(time, unixSign).format('YYYY-MM-DD HH:mm:ss');
          str = moment(str, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
          break;
        case 'dd-MM-yyyy HH:mm':
          str = moment(time, unixSign).format('YYYY-MM-DD HH:mm:ss');
          str = moment(str, 'YYYY-MM-DD HH:mm').format('DD-MM-YYYY HH:mm');
          break;
        case 'yyyy-MM-dd HH:mm:ss':
          str = moment(time, unixSign).format('YYYY-MM-DD HH:mm:ss');
          str = moment(str, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
          break;
        case 'dd-MM-yyyy HH:mm:ss':/*日月年格式*/
          str = moment(time, unixSign).format('YYYY-MM-DD HH:mm:ss');
          str = moment(str, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss');
          break;
        case 'dd-MM-yyyy':
          str = moment(time, unixSign).format('YYYY-MM-DD HH:mm:ss');
          str = moment(str, 'YYYY-MM-DD').format('DD-MM-YYYY');
          break;  
        default:
          str = moment(time, unixSign).format('YYYY-MM-DD HH:mm:ss');
          str = moment(str, 'YYYY-MM-DD').format('YYYY-MM-DD');
          break;
      }
    } else if (type === 2) {/*时间格式转化成时间戳(Unix 时间戳)*/
      switch (formatStr) {/*当前时间转成时间戳*/
        case 'dd-MM-yyyy':
          str = moment(time, 'DD-MM-YYYY').format('YYYY-MM-DD');
          str = moment(str).valueOf();
          break;
        case 'yyyy-MM-dd HH:mm':
          str = moment(time, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
          str = moment(str).valueOf();
          break;
        case 'dd-MM-yyyy HH:mm':
          str = moment(time, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm');
          str = moment(str).valueOf();
          break;
        case 'yyyy-MM-dd HH:mm:ss':
          str = moment(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
          str = moment(str).valueOf();
          break;
        case 'dd-MM-yyyy HH:mm:ss':
          str = moment(time, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
          str = moment(str).valueOf();
          break;
        default:
          str = moment(time, 'YYYY-MM-DD').format('YYYY-MM-DD');
          str = moment(str).valueOf();
          break;
      }
    } else if (type === 3) {/*根据UTC时间获取本地时间*/
      let localTime = moment.parseZone(time).local();
      switch (formatStr) {
        case 'dd-MM-yyyy':
          str = localTime.format('DD-MM-YYYY');
          break;
        case 'yyyy-MM-dd HH:mm':
          str = localTime.format('YYYY-MM-DD HH:mm');
          break;
        case 'dd-MM-yyyy HH:mm':
          str = localTime.format('DD-MM-YYYY HH:mm');
          break;
        case 'yyyy-MM-dd HH:mm:ss':
          str = localTime.format('YYYY-MM-DD HH:mm:ss');
          break;
        case 'dd-MM-yyyy HH:mm:ss':
          str = localTime.format('DD-MM-YYYY HH:mm:ss');
          break;
        default:
          str = localTime.format('YYYY-MM-DD');
          break;
      }
    } else {
      switch (formatStr) {/*转成当前格式*/
        case 'dd-MM-yyyy':
          str = moment(time, 'YYYY-MM-DD').format('DD-MM-YYYY');
          break;
        case 'yyyy-MM-dd HH:mm':
          str = moment(time, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
          break;
        case 'dd-MM-yyyy HH:mm':
          str = moment(time, 'YYYY-MM-DD HH:mm').format('DD-MM-YYYY HH:mm');
          break;
        case 'yyyy-MM-dd HH:mm:ss':
          str = moment(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
          break;
        case 'dd-MM-yyyy HH:mm:ss':/*日月年格式*/
          str = moment(time, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss');
          break;
        default:
          str = moment(time, 'YYYY-MM-DD').format('YYYY-MM-DD');
          break;
      }
    }
    return str;
  },


  /*根据时区id显示时间*/
  /*
  默认可以不传formatStr就是加上指定时区时间转化成零时区的时间戳
  如果formatStr存在就是把零时区的时间变成指定时区的时间转化成当前的时间格式的时间
  * */

  formatZoneDate: function(time,formatStr,type, timeZoneId){
    let str = '';
    if (time === 0 || time >= 253370736000000) {
      return;
    }
    if (!time) {
      return;
    }
    if(!timeZoneId){
      timeZoneId = 'Etc/UTC';
    }
    if(type == 1){
      switch (formatStr) {/*当前时间转成时间戳*/
        case 'dd-MM-yyyy':
          str = moment(time, 'DD-MM-YYYY').format('YYYY-MM-DD');
          str = momentTimezone.tz(str,timeZoneId).format();
          str = moment(str).valueOf();
          break;
        case 'yyyy-MM-dd HH:mm':
          str = moment(time, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
          str = momentTimezone.tz(str,timeZoneId).format();
          str = moment(str).valueOf();
          break;
        case 'dd-MM-yyyy HH:mm':
          str = moment(time, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm');
          str = momentTimezone.tz(str,timeZoneId).format();
          str = moment(str).valueOf();
          break;
        case 'yyyy-MM-dd HH:mm:ss':
          str = moment(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
          str = momentTimezone.tz(str,timeZoneId).format();
          str = moment(str).valueOf();
          break;
        case 'dd-MM-yyyy HH:mm:ss':
          str = moment(time, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
          str = momentTimezone.tz(str,timeZoneId).format();
          str = moment(str).valueOf();
          break;
        default:
          str = moment(time, 'YYYY-MM-DD').format('YYYY-MM-DD');
          str = momentTimezone.tz(str,timeZoneId).format();
          str = moment(str).valueOf();
          break;
      }
    }else if(type == 2){
      switch (formatStr) {/*转成当前格式*/
        case 'yyyy-MM-dd':
          str = momentTimezone.tz(time,timeZoneId).format('YYYY-MM-DD');
          break;
        case 'dd-MM-yyyy':
          str = momentTimezone.tz(time,timeZoneId).format('DD-MM-YYYY');
          break;
        case 'yyyy-MM-dd HH:mm':
          str = momentTimezone.tz(time,timeZoneId).format('YYYY-MM-DD HH:mm');
          break;
        case 'dd-MM-yyyy HH:mm':
          str =  momentTimezone.tz(time,timeZoneId).format('DD-MM-YYYY HH:mm');
          break;
        case 'yyyy-MM-dd HH:mm:ss':
          str =  momentTimezone.tz(time,timeZoneId).format('YYYY-MM-DD HH:mm:ss');
          break;
        case 'dd-MM-yyyy HH:mm:ss':/*日月年格式*/
          str =  momentTimezone.tz(time,timeZoneId).format('DD-MM-YYYY HH:mm:ss');
          break;
        default:
          str =  momentTimezone.tz(time,timeZoneId).format('YYYY-MM-DD');
          break;
      }
    }
    return str;
  },

  moreInfo: function (e) {
    console.log(e);
  },
  //统一系统中报表名的字符限制方式和提示方式
  hasSpecialCharacters(value) {
    value = value == undefined ? "" : value;
    let str = ['\\', '/', '.', ':', '*', '?', '"', '<', '>', '|', '#', '%'];
    let boo = 0;
    for (const key in str) {
      if (value.indexOf(str[key]) != -1) {
        boo = 1;
        break;
      }
    }
    return boo == 1;
  },
  //深拷贝
  deepClone: function (obj) {
    let deepClone = (obj) => {
      let objClone = Array.isArray(obj) ? [] : {};
      if (obj && typeof obj === "object") {
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) {
            //判断ojb子元素是否为对象，如果是，递归复制
            if (obj[key] && typeof obj[key] === "object") {
              objClone[key] = deepClone(obj[key]);
            } else {
              //如果不是，简单复制
              objClone[key] = obj[key];
            }
          }
        }
      }
      return objClone;
    }
    return deepClone(obj);
  },
  //判断是否有权限
  getPermission: function (data, array) {
    if (data.permissionCodes) {
      let index = array.findIndex(value => {
        return data.permissionCodes.findIndex(code => {
          return code === value;
        }) > -1;
      });
      return index > -1
    } else {
      return false;
    }
  },
  //将对象转数组，主要用于搜索条件的转化
  objToArrar: function (obj) {
    let array = [];
    for (let key in obj) {
      array.push(obj[key]);
    }
    return array;
  },
  numArray:[2,3,4,5,6,7,8,9],
  lowerCaseLetter:['a','b','c','d','e','f','g','h','j','k','m','n','p','q','r','s','t','w','v','u','x','y','z'],
  upperCaseLetter:['A','B','C','D','E','F','G','H','J','K','M','N','P','Q','R','S','T','W','V','U','X','Y','Z'],
  specialCharacters:['!','@','#','$','%','^','&','*','(',')'],
  //生成随机密码
  generateRandomPassword: function () {
    let passwordArray = [];
    let passwordStr = '';
    let array = [
      Math.floor(Math.random() * this.numArray.length),
      Math.floor(Math.random() * this.lowerCaseLetter.length),
      Math.floor(Math.random() * this.upperCaseLetter.length),
      Math.floor(Math.random() * this.specialCharacters.length),
    ];
    for (let i = 0; i < 8; i++) {
      let number = Math.floor(Math.random() * 10);
      if (number > 6) {
        passwordArray.splice(Math.floor(Math.random() * passwordArray.length), 0, this.numArray[Math.floor(Math.random() * this.numArray.length)]);
      } else if (number > 3 && number < 7) {
        passwordArray.splice(Math.floor(Math.random() * passwordArray.length), 0, this.lowerCaseLetter[Math.floor(Math.random() * this.lowerCaseLetter.length)]);
      } else if (number > 0 && number < 4) {
        passwordArray.splice(Math.floor(Math.random() * passwordArray.length), 0, this.upperCaseLetter[Math.floor(Math.random() * this.upperCaseLetter.length)]);
      } else {
        passwordArray.splice(Math.floor(Math.random() * passwordArray.length), 0, this.specialCharacters[Math.floor(Math.random() * this.specialCharacters.length)]);
      }
    }
    passwordArray.splice(Math.floor(Math.random() * passwordArray.length), 0, this.numArray[array[0]]);
    passwordArray.splice(Math.floor(Math.random() * passwordArray.length), 0, this.lowerCaseLetter[array[1]]);
    passwordArray.splice(Math.floor(Math.random() * passwordArray.length), 0, this.upperCaseLetter[array[2]]);
    passwordArray.splice(Math.floor(Math.random() * passwordArray.length), 0, this.specialCharacters[array[3]]);
    for (let char of passwordArray) {
      passwordStr += char;
  }
    return passwordStr;
  },
  failureReasons : [
    { value: 0, label: "Card Disabled" },
    // {value:0, label:"Card Expired"},
    { value: 0, label: "Card Unassigned" },
    { value: 0, label: "Illegal Time Period" },
    { value: 0, label: 'Interlocking Door' },
    // {value:0, label:'Invalid Badge'},
    { value: 0, label: "Out of Access Code Schedule" },
    // { value: 0, label: 'The occupancy limit was exceeded' },
    { value: 0, label: 'Occupancy Limit Reached' },
    { value: 0, label: "Unauthorized Access" },
    { value: 0, label: "Authentication Process Error" },
    { value: 0, label: "Unregistered Card" },
    { value: 0, label: "User Access Code Inactive" },
    { value: 0, label: "User Access Code Expired" },
    { value: 0, label: "User Access Code Disabled" },
    { value: 0, label: "User Inactive" },
    { value: 0, label: "User Expired" },
    { value: 0, label: "User Disabled" },
    { value: 0, label: "User No Access Code" },
    // { value: 0, label: 'Violation of anti-submarine' },
    { value: 0, label: 'Anti-passback Violation' },
    // {value:0, label:"Wrong PIN"},
    { value: 0, label: "PlN-Auth Failed" },
    { value: 0, label: "Authentication Method Error" },
    // { value: 0, label: "PIN Time Out" },
    { value: 0, label: "Multi-Auth Failed" },
    { value: 0, label: "Same Person" },
    { value: 0, label: "Authentication Time Out" },
  ],

  /********************************公共方法*********************************/
};
export default common;



//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/js/common.js
// module id = IkP9
// module chunks = 15